"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
var _classCallCheck2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/grow-task-admin/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _axios = _interopRequireDefault(require("axios"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
var _utils = require("@/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var pendingQueue = new Map();
var CancelToken = _axios.default.CancelToken;
var judgePendingFunc = function judgePendingFunc(config) {
  if (pendingQueue.has("".concat(config.method, "->").concat(config.url))) {
    pendingQueue.get("".concat(config.method, "->").concat(config.url))();
  }
};

// 删除队列中对应已执行的请求
var removeResolvedFunc = function removeResolvedFunc(config) {
  if (pendingQueue.has("".concat(config.method, "->").concat(config.url))) {
    pendingQueue.delete("".concat(config.method, "->").concat(config.url));
  }
};

/**
 * @constructor Service
 * @description common service class for axios ajax
 * @param {Object} axios options
 * @example Class YourService extends Service
 */
var Service = exports.default = /*#__PURE__*/function () {
  function Service(options) {
    (0, _classCallCheck2.default)(this, Service);
    options = options || {};
    var baseURL = process.env.VUE_APP_BASE_API;
    this.options = (0, _merge2.default)({
      baseURL: baseURL,
      timeout: 0,
      headers: {}
    }, options);
    this.http = this.createInstance(this.options);
    this.setRequestInterceptor();
    this.setResponseInterceptor();
  }

  /**
   * @description create axios instance
   * @param {Object} options axios instance options
   * @return {Object} axios instance
   */
  (0, _createClass2.default)(Service, [{
    key: "createInstance",
    value: function createInstance(options) {
      var opt = Object.prototype.toString.call(options).slice(8, -1).toLowerCase() === 'object' ? options : {};
      return _axios.default.create(opt);
    }

    /**
     * @description set request interceptor, only the last interceptor will be reserved
     * @param {Function} success request success callback handler
     * @param {Function} error request error callbach handler
     * @return {Object} xmlHttpRequest config / config error
     */
  }, {
    key: "setRequestInterceptor",
    value: function setRequestInterceptor(success, error) {
      // if request interceptor setted then eject it
      if (typeof this._requestInterceptor !== 'undefined') {
        this.http.interceptors.request.eject(this._requestInterceptor);
      }
      this._requestInterceptor = this.http.interceptors.request.use(function (config) {
        judgePendingFunc(config);
        config.cancelToken = new CancelToken(function (cb) {
          // cb就是取消该请求的方法，调用它就能cancel掉当前请求
          pendingQueue.set("".concat(config.method, "->").concat(config.url), cb);
        });
        var requestConfig;
        var token = (0, _auth.getToken)();
        var Authorization = token;
        var platform_id = localStorage.getItem('platform_id');
        requestConfig = _objectSpread(_objectSpread({}, config), {}, {
          headers: _objectSpread({}, config.headers || {})
        });
        if (config.url != '/login' && Authorization) {
          requestConfig.headers['token'] = Authorization;
          requestConfig.headers['user'] = (0, _auth.getUser)();
          requestConfig.headers['platform'] = (0, _utils.getPlatformById)(String(platform_id));
          requestConfig.headers['Authorization'] = 'Bearer ' + Authorization; // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        if (platform_id) {
          requestConfig.headers['platformid'] = platform_id;
        }
        if (typeof success === 'function') {
          success(requestConfig);
        }
        return requestConfig;
      }, function (err) {
        if (typeof error === 'function') {
          error(err);
        }
        return Promise.reject(err);
      });
    }

    /**
     * @description set response interceptor, only the last interceptor will be reserved
     * @param {Function} success response success callback handler
     * @param {Function} error response error callbach handler
     * @return {Object} xmlHttpRequest response / xmlHttpRequest error
     */
  }, {
    key: "setResponseInterceptor",
    value: function setResponseInterceptor(success, error) {
      // if response interceptor setted then eject it
      if (typeof this._responseInterceptor !== 'undefined') {
        this.http.interceptors.response.eject(this._responseInterceptor);
      }
      this._responseInterceptor = this.http.interceptors.response.use(function (response) {
        removeResolvedFunc(response.config);
        if (typeof success === 'function') {
          return success(response.data);
        } else if (Number(response.status) === 200) {
          return response.data;
        } else if ([402, 405].includes(response.data.code)) {
          _store.default.dispatch('LogOut').then(function () {
            (0, _elementUi.Message)({
              message: '登录已过期，请重新登录',
              duration: 500,
              type: 'error'
            });
            setTimeout(function () {
              location.reload();
            }, 1001);
          });
        }
        return response.data;
      }, function (err) {
        if (err.response && err.response.status == 401) {
          _store.default.dispatch('LogOut').then(function () {
            (0, _elementUi.Message)({
              message: '登录已过期，请重新登录',
              duration: 500,
              type: 'error'
            });
            setTimeout(function () {
              location.reload();
            }, 1001);
          });
        }
        if (typeof error === 'function') {
          error(err);
        } else {
          // Message.error('请求超时, 请重试!')
        }
        (0, _elementUi.Message)({
          type: 'error',
          message: err.message
        });
        return Promise.reject(err);
      });
    }
  }]);
  return Service;
}();